



























import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { FileListItem, ElUploadInternalFileDetail } from '@/typings/files'
import { uploadImgUrl, deletePicture } from '@/api/upload'
import { AppModule } from '@/store/modules/app'

type imgType = 1 | 2 | 3 | 4
const imgCheckList = ['image/jpeg', 'image/jpg', 'image/png']

@Component({
  name: 'multi-photo'
})
export default class extends Vue {
  @Prop({ required: true }) imgType!: imgType
  @Prop({ default: false }) hardDelete!: boolean
  @Prop({ default: () => ({ '--width': '148px', '--height': '148px' }) }) styles!: any
  @Prop() photoList!: any[]
  @PropSync('iconList', { required: true }) iconPathList!: string[] // 图片相对路径

  private uploadImgUrl = uploadImgUrl
  fileList: any[] = []
  realFileList: any[] = []
  private dialogImageUrl: string = ''
  private dialogVisible: boolean = false
  created() {
    this.fileList = this.photoList.map((item: string) => ({ name: item.split('/').pop(), url: item }))
  }
  get disabled() {
    return AppModule.uploadDisabled
  }
  handleBeforeRemove(file: FileListItem, fileList: FileListItem[]) {
    if (file && file.status === 'success') {
      return this.$confirm('确认移除该图片?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
    }
  }
  async handleRemove(file: FileListItem, fileList: FileListItem[]) {
    if (file && file.status === 'success') {
      let url = file.url
      let domain = 'http://pics.tutuapp.com/'
      this.iconPathList.splice(this.iconPathList.indexOf(url), 1)
      this.fileList = fileList.splice(0)
      if (this.hardDelete) {
        let res: any = await deletePicture({
          path: url.includes(domain) && url.split(domain)[1]
        })
        if (res.status.code === 0) {
          this['$message'].success('图片删除成功!')
        } else {
          this['$message'].error('图片删除失败!')
        }
      } else {
        this['$message'].success('图片删除成功!')
      }
    }
  }
  handlePictureCardPreview(file: FileListItem) {
    this.dialogImageUrl = file.url
    this.dialogVisible = true
  }
  // methods
  beforeAvatarUpload(file: ElUploadInternalFileDetail) {
    const isJPG = imgCheckList.includes(file.type)
    const isLt500K = file.size / 1024 / 1024 < 5
    if (!isJPG) {
      // (this.$refs['MultiPhoto'] as any).abort()
      this['$message'].error('上传图片只能是JPG,PNG,JEPG格式!')
    }
    if (!isLt500K) {
      // (this.$refs['MultiPhoto'] as any).abort()
      this['$message'].error('上传图片大小不能超过 5M!')
    }
    if (isJPG && isLt500K) {
      AppModule.SetUploadDisabled(true)
    }
    return isJPG && isLt500K
  }
  handleAvatarSuccess(res: any, file: ElUploadInternalFileDetail) {
    console.log(res)
    if (res.status.code === 0) {
      this.iconPathList.push(res.data)
      this['$message'].success('图片上传成功!')
    } else {
      this['$message'].error(res.status.message)
    }
    // 无论是否上传成功都要恢复原本可上传状态
    AppModule.SetUploadDisabled(false)
  }
  handleError() {
    this['$message'].error('图片上传失败!')
    AppModule.SetUploadDisabled(false)
  }
  // @Watch('photoList', { immediate: true, deep: true })
  // onImageUrlListChanged(val: any[], oldVal: any[]) {
  //   this.fileList = val.map((item: string) => ({ name: item.split('/').pop(), url: item }))
  // }
}
